<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Buy Bundle'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    <tidy-card>
      <tidy-row class="vertical-align-center extra-bottom-padding">
        <tidy-image
          [src]="'assets/img/coupon.svg'"
          class="title-size" />
        <tidy-text
          [header]="'Save $50 on TIDY!'" />
      </tidy-row>

      <tidy-row class="vertical-align-center extra-bottom-padding">
        <tidy-image
          [src]="'assets/img/salary.svg'"
          class="body-size" />
        <tidy-text
          [body]="'Pay $500, get $550 in credit'" />
      </tidy-row>

      <tidy-row class="vertical-align-center extra-bottom-padding">
        <tidy-image
          [src]="'assets/img/shield-green.svg'"
          class="body-size" />
        <tidy-text
          [body]="'Risk-free with Satisfaction Guarantee'" />
      </tidy-row>

      <tidy-row class="vertical-align-center">
        <tidy-image
          [src]="'assets/img/checkmark-circle-green.svg'"
          class="body-size" />
        <tidy-text
          [body]="'Cancel anytime'" />
      </tidy-row>
    </tidy-card>

    <tidy-row>
      <tidy-text
        [helper]="'Want to save money on your Home Cleanings? Purchase $550 in TIDY Credit for only $500. Try this risk-free - you can still cancel anytime and are eligible for our Satisfaction Guarantee. Your card on file will be charged $500 and $550 credit will be added to your account. '" />
      <tidy-text
        [actionBody]="'Learn More'"
        (action)="gotToLearnMore()"
        class="link" />
    </tidy-row>

    <tidy-error-message
      [text]="errorMessage" />

    <div style="display: flex; justify-content: space-between">
      <tidy-button
        [text]="'Go Back'"
        [action]="boundGoBack"
        class="secondary" />
      <tidy-button
        [text]="'Pay $500 for Bundle'"
        [action]="boundConfirm"
        class="primary" />
    </div>

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
